import { render, staticRenderFns } from "./overageList.vue?vue&type=template&id=5c5e9964"
import script from "./overageList.vue?vue&type=script&lang=js"
export * from "./overageList.vue?vue&type=script&lang=js"
import style0 from "./overageList.vue?vue&type=style&index=0&id=5c5e9964&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports